<template>
  <div class="container">
    <phone-directory
      v-model="directory"
      :disabled="isEditorDisabled"
      class="phone-directory"
    ></phone-directory>
    <div v-if="!isEditorDisabled" class="text-end mt-4">
      <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import PhoneDirectory from "../components/PhoneDirectory";

export default {
  components: {
    PhoneDirectory,
    ScButton
  },
  data() {
    return {
      rawDirectory: [],
      directory: []
    };
  },
  computed: {
    isEditorDisabled() {
      return this.$isCallCenter;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupDirectory();
    },
    async setupDirectory() {
      this.rawDirectory = await this.fetchDirectory();
      this.directory = this.rawDirectory.phone_directory.groups;
    },
    async fetchDirectory() {
      const { id } = this.$route.params;

      const response = await baanRueJaiClient.admin.projects.getPhoneDirectory(
        id
      );

      return response.data.result;
    },
    async handleClickSave() {
      const { id } = this.$route.params;
      /* eslint-disable camelcase -- API payload */
      const phone_directory = {
        ...this.rawDirectory.phone_directory,
        groups: this.directory
      };
      const params = { phone_directory };
      /* eslint-enable camelcase */

      await baanRueJaiClient.admin.projects.postPhoneDirectory(
        id,
        params
      );

      this.$router.push({ ...this.$route, name: "ProjectDetailPage" });
    }
  }
};
</script>

<style lang="scss" scoped>
.phone-directory {
  margin-top: -30px;
}
</style>
